import { AppState } from "..";
import { SET_INTERCOM_FIELD, RESET_INTERCOM_STATE, FETCH_INTERCOM_SETTINGS_SUCCESS, UPDATE_INTERCOM_SETTINGS_REQUEST, UPDATE_INTERCOM_SETTINGS_SUCCESS, UPDATE_INTERCOM_SETTINGS_FAILURE } from "../actions/intercomActions";
import { BillsbyAdminAction } from "../models/BillsbyAdminAction";
import { IIntercomSettings } from "../models/Intercom";

export interface IIntercomReducer {
  name: string,
  adminId: string,
  isUpdatingSettingsRequest: boolean,
  isUpdatingSettingsSuccess: boolean,
  isUpdatingSettingsFailure: boolean
}

const initialState: IIntercomReducer = {
  name: "",
  adminId: "",
  isUpdatingSettingsRequest: false,
  isUpdatingSettingsSuccess: false,
  isUpdatingSettingsFailure: false
}



export default function intercomReducer(state: IIntercomReducer = initialState, action: BillsbyAdminAction, store: AppState) {
  switch (action.type) {
    case SET_INTERCOM_FIELD:
      return { ...state, [action.fieldName]: action.fieldValue }
    case FETCH_INTERCOM_SETTINGS_SUCCESS: {
      const settings = action.response as IIntercomSettings;
      return { ...state, name: settings.crmAdminName, adminId: String(settings.crmAdminId) }
    }
    case UPDATE_INTERCOM_SETTINGS_REQUEST:
      return { ...state, isUpdatingSettingsRequest: true, isUpdatingSettingsSuccess: false, isUpdatingSettingsFailure: false }
    case UPDATE_INTERCOM_SETTINGS_SUCCESS:
      return { ...state, isUpdatingSettingsRequest: false, isUpdatingSettingsSuccess: true, isUpdatingSettingsFailure: false }
    case UPDATE_INTERCOM_SETTINGS_FAILURE:
      return { ...state, isUpdatingSettingsRequest: false, isUpdatingSettingsSuccess: false, isUpdatingSettingsFailure: true }

    case RESET_INTERCOM_STATE:
      return { ...initialState }

    default:
      return state;
  }
}